import React, { useState } from 'react';
import { PaddleIcon } from './icons';

/**
 * The site's main logo. Renders /logo.jpg (place the file at
 * frontend/public/logo.jpg — CRA serves anything in public/ from the site
 * root) everywhere the brand mark appears: kiosk headers, the admin
 * sidebar, and both login screens. Falls back to the paddle glyph if the
 * file hasn't been added yet or fails to load, so nothing breaks in the
 * meantime.
 */
export default function Logo({ size = 24, style, square = false }) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return <PaddleIcon size={size} color="var(--blue)" style={style} />;
  }

  return (
    <img
      src="/logo.jpg"
      alt="Picklers Lounge"
      onError={() => setFailed(true)}
      style={{
        width: size,
        height: size,
        objectFit: 'cover',
        borderRadius: square ? 6 : '50%',
        display: 'inline-block',
        verticalAlign: 'middle',
        flexShrink: 0,
        ...style,
      }}
    />
  );
}
